import { Stack, Typography, useTheme } from '@mui/material'

const NoContent = ({label}) => {
  const theme = useTheme()
  return (
    <Stack
      sx={{
        alignItems: 'center',
        border: `1px dashed ${theme.palette.grey[200]}`,
        borderRadius: 4,
      }}>
      <Typography component={'span'} sx={{fontSize: 12, color: theme.palette.grey[700], marginTop: 6, marginBottom: 6}}>{label}</Typography>
    </Stack>
  )
}

export default NoContent